import React from 'react'
import Section1 from './Section1/Section1'

export default function Contact() {
  return (
    <div className='w-full overflow-hidden px-4 lg:px-12 '>
      <Section1/>
    </div>
  )
}
